export default __webpack_public_path__ + "static/media/multi_audit_3.b3694268.svg";